import {RouterModule} from '@angular/router';
import {NgModule} from '@angular/core';
import {AppMainComponent} from './app.main.component';
import {AppNotfoundComponent} from './pages/app.notfound.component';
import {AppContactusComponent} from './pages/app.contactus.component';
import {AppErrorComponent} from './pages/app.error.component';
import {AppAccessdeniedComponent} from './pages/app.accessdenied.component';
import {AppLandingComponent} from './pages/app.landing.component';
import {AppInvoiceComponent} from './pages/app.invoice.component';
import {AppHelpComponent} from './pages/app.help.component';
import { HomeComponent } from './home/home.component';
import { NewsAddComponent } from './news/news-add/news-add.component';
import { NewsGetDropDownOptionsResolverService } from './news/services/news-get-drop-down-options-resolver.service';
import { MessageViewComponent } from './message/message-view/message-view.component';
import { MessageGetDropdownOptionsResolverService, MessageGetResolverService } from './message/services/message-get-dropdown-options-resolver.service';
import { HomePageResolverService } from './home/services/home-component-resolver.service';
import { ViewnewsitemComponent } from './news/news-view-item/news-view-item.component';
import { NewsGetResolverService } from './news/services/news-get-resolver.service';
import { MessageAddComponent } from './message/message-add/message-add.component';
import { MessageAddGetDropdownOptionsResolverService } from './message/services/message-get-dropdown-options-resolver.service';
import { MessageDetailComponent } from './message/message-detail/message-detail.component';
import { CalendarComponent } from './calendar/calendar.component';
import { DataMiningSearchComponent } from './datamining/datamining-search/datamining-search.component';
import { DataminingDetailComponent } from './datamining/datamining-detail/datamining-detail.component';
import { DataMiningResolverService } from './datamining/resolverservices/datmining-resolver.service';
import { UserViewComponent } from './user/user-view/user-view.component';
import { UserViewResolverService } from './user/services/user-view-resolver.service'
import { UserEditResolverService } from './user/services/user-edit-resolver.service'
import { UserEditDropdowOptionsResolverService } from './user/services/user-edit-resolver.service'
import { UserInviteComponent } from './user/user-invite/user-invite.component';
import { UserGetDropdowOptionsResolverService } from './user/services/user-get-dropdow-options-resolver.service';
import { ResourceCenterViewComponent } from './resource/resource-center-view/resource-center-view.component';
import{ResourceCenterResolverService, ResourceGetResolverService, ResourceListResolverService, ResourceSearchResolverService} from './resource/services/resource-center-resolver.service'
import { ResourceListViewComponent } from './resource/resource-list-view/resource-list-view.component';
import { ResourceAddEditComponent } from './resource/resource-add-edit/resource-add-edit.component';
import {CanDeactivateGuard} from './common/guards/edit-can-deactivate.guard';
import { UserPasswordResetComponent } from './user/user-password-reset/user-password-reset.component';
import { UserPasswordResetResolverService } from './user/services/user-password-reset-resolver.service';
import { UserLoginComponent } from './user/user-login/user-login.component';
import { UserForgotpasswordComponent } from './user/user-forgotpassword/user-forgotpassword.component';
import { AuthGuard } from './common/guards/auth.guard';
import { UserEditComponent } from './user/user-edit/user-edit.component';
import { MemberAddComponent } from './member/member-add/member-add.component';
import { MemberViewComponent } from './member/member-view/member-view.component';
import { MemberEditComponent } from './member/member-edit/member-edit.component';
import{MemberGetDropdownOptionsResolverService,  MemberOfficeLocationsResolverService, MemberResolverService, MemberTerritoryOptionsResolverService, MemberTerritoryResolverService} from './member/services/member-resolver.service';
import { DealAddComponent } from './deal/deal-add/deal-add.component';
import { DealGetDropDownOptionsResolverService, DealEditGetResolverService, DealViewGetDealsResolverService, DealAdminDealsResolverService } from './deal/services/deal-get-drop-down-options-resolver.service';
import { DealDetailComponent } from './deal/deal-detail/deal-detail.component';
import { DealGetResolverService } from './deal/services/deal-get-drop-down-options-resolver.service';
import { DealEditComponent } from './deal/deal-edit/deal-edit.component';
import { DealNoteComponent } from './deal/deal-note/deal-note.component';
import { DealNoteGetResolverService } from './deal/services/deal-get-drop-down-options-resolver.service';
import { DealAdditionalCommunicationComponent } from './deal/deal-additional-communication/deal-additional-communication.component';
import { DealAdditionalCommunicationRecipientGetResolverService } from './deal/services/deal-get-drop-down-options-resolver.service';
import { DealViewComponent } from './deal/deal-view/deal-view.component';
import { SearchComponent } from './search/search.component';
import { MemberterritoryEditComponent } from './member/memberterritory-edit/memberterritory-edit.component';
import { ReportComponent } from './report/report.component';
import { ResourceNames } from './common/constants';
import { SearchGetDropdownOptionResolverServiceService } from './search/services/search-get-dropdown-option-resolver-service.service'
@NgModule({
    imports: [
        RouterModule.forRoot([
            {
                path: '',
                component: AppMainComponent,
                children: [                   
                    { path: '', 
                        resolve: { data: HomePageResolverService },
                        component: HomeComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'news/add',
                        resolve: { options: NewsGetDropDownOptionsResolverService },
                        component: NewsAddComponent,
                        canActivate: [AuthGuard],
                        data: { requiredResources: [ResourceNames.ADMIN]},
                    },                  
                    {
                        path: 'news/:id',
                        component: ViewnewsitemComponent,
                        resolve: {
                            newsItem: NewsGetResolverService,                          
                        },
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'message/view',
                        resolve: { options: MessageGetDropdownOptionsResolverService },
                        component: MessageViewComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'message/add',
                        resolve: { options: MessageAddGetDropdownOptionsResolverService },
                        component: MessageAddComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'message/:id',
                        component: MessageDetailComponent,
                        resolve: {
                            message: MessageGetResolverService,
                        },
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'calendar',
                        component: CalendarComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'datamining-search',
                        component: DataMiningSearchComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'datamining/:id',
                        component: DataminingDetailComponent,
                        resolve: {
                            transaction: DataMiningResolverService,
                        },
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'help',
                        component: AppHelpComponent,
                        canActivate: [AuthGuard],
                    },
                    
                    {
                        path: 'resource-center/view',
                        resolve: { resourcecategories: ResourceCenterResolverService },
                        component: ResourceCenterViewComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'resource-list/:categoryid',
                        resolve: { resources: ResourceListResolverService },
                        component: ResourceListViewComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'resource-list/search/:searchterm',
                        resolve: { resources: ResourceSearchResolverService },
                        component: ResourceListViewComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'resource/edit/:id',                                
                        resolve: { resource: ResourceGetResolverService, resourcecategories: ResourceCenterResolverService},
                        canDeactivate: [CanDeactivateGuard],
                        component: ResourceAddEditComponent,
                        canActivate: [AuthGuard],
                        data: { requireAuthorization: true },
                    },
                    {
                        path: 'resource/new',          
                        resolve: { resourcecategories: ResourceCenterResolverService },    
                        canDeactivate: [CanDeactivateGuard],     
                        component: ResourceAddEditComponent,
                        canActivate: [AuthGuard],
                        data: { requireAuthorization: true },
                    },
                    {
                        path: 'user/invite',
                        resolve: { options: UserGetDropdowOptionsResolverService },
                        component: UserInviteComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'user/:id',
                        component: UserViewComponent,
                        resolve: {
                            user: UserViewResolverService,
                        },
                        canActivate: [AuthGuard],
                    },                   
                    {
                        path: 'user/edit/:id',
                        component: UserEditComponent,
                        resolve: {
                            user: UserEditResolverService,
                            options: UserEditDropdowOptionsResolverService,
                        },
                        canActivate: [AuthGuard],
                        data: { requireAuthorization: true },
                    },
                    { path: 'login', component: UserLoginComponent },
                    { path: 'forgotpassword', component: UserForgotpasswordComponent },
                    {
                        path: 'welcome/:userid/:token',
                        component: UserPasswordResetComponent,
                        resolve: {
                            parms: UserPasswordResetResolverService
                        }
                    },
                    {
                        path: 'forgotpassword/:userid/:token',
                        component: UserPasswordResetComponent,
                        resolve: {
                            parms: UserPasswordResetResolverService
                        }
                    },
                    {
                        path: 'member/new',
                        resolve: { options: MemberGetDropdownOptionsResolverService },
                        component: MemberAddComponent,
                        canActivate: [AuthGuard],
                    },                   
                    {
                        path: 'member/:id',
                        component: MemberViewComponent,
                        resolve: {
                            member: MemberResolverService,
                            officelocations: MemberOfficeLocationsResolverService,
                            territories: MemberTerritoryResolverService
                        },
                        canActivate: [AuthGuard],
                    },                                       
                    {
                        path: 'member/edit/:id',
                        component: MemberEditComponent,
                        resolve: {
                            member: MemberResolverService,
                            options: MemberGetDropdownOptionsResolverService,
                            officelocations: MemberOfficeLocationsResolverService
                        },
                        canActivate: [AuthGuard],
                        data: { requireAuthorization: true },
                    },
                    {
                        path: 'member/editterritory/:id',
                        component: MemberterritoryEditComponent,
                        resolve: {
                            member: MemberResolverService,
                            territories: MemberTerritoryResolverService,
                            options: MemberTerritoryOptionsResolverService
                        
                        },
                        canActivate: [AuthGuard],
                    },  
                    
                    {
                        path: 'deal/new',
                        resolve: { options: DealGetDropDownOptionsResolverService },
                        component: DealAddComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'deal/view',
                        resolve: { deals: DealViewGetDealsResolverService },
                        component: DealViewComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'deal/viewadmin',
                        resolve: { deals: DealAdminDealsResolverService },
                        component: DealViewComponent,
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'deal/:id',
                        component: DealDetailComponent,
                        resolve: {
                            deal: DealGetResolverService,
                        },
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'deal/edit/:id',
                        component: DealEditComponent,
                        resolve: {
                            deal: DealEditGetResolverService,
                            options: DealGetDropDownOptionsResolverService 
                        },
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'deal/note/:id',
                        component: DealNoteComponent,
                        resolve: {
                            notes: DealNoteGetResolverService
                        },
                        canActivate: [AuthGuard],
                    },                    
                    {
                        path: 'deal/additionalcommunication/:id',
                        component: DealAdditionalCommunicationComponent,
                        resolve: {
                            users: DealAdditionalCommunicationRecipientGetResolverService
                        },
                        canActivate: [AuthGuard],
                    },                          
                    {
                        path: 'search',
                        component: SearchComponent,
                        resolve: { options: SearchGetDropdownOptionResolverServiceService },
                        canActivate: [AuthGuard],
                    },
                    {
                        path: 'reports',
                        component: ReportComponent,
                        canActivate: [AuthGuard],
                    },
                    { path: 'unauthorized', component: AppAccessdeniedComponent },
                    { path: 'error', component: AppErrorComponent },
                ]
            },
        ], {scrollPositionRestoration: 'enabled'})
    ],
    exports: [RouterModule]
})
export class AppRoutingModule {
}
